import React from 'react';
import CheckoutContainer from '../../containers/step3_settings/CheckoutContainer';

const StepThree = ({ campaignData }) => {
  return (
    <CheckoutContainer 
      campaignData={campaignData}
      isPaymentMode={false} 
    />
  );
};

export default StepThree;